import React, {useEffect, useState} from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";
import {getTrgtAlarm} from "../../api/apiClient";

const ComboSendTargetFault = ({
                                propTitle = '발송 대상 장애',
                                propDefaultValue,
                                propOnChange = null,
                              }) => {

  // 발송 대상 장애 목록
  const [trgtAlarmList, setTrgtAlarmList] = useState([]);

  useEffect(() => {
    // 발송 대상 장애
    getTrgtAlarm()
        .then((res) => {
          setTrgtAlarmList(res.data.data.list);
        });
  }, [])

  return (
      <Form.Group as={Row} controlId={"sendTargetFault"}>
        <Form.Label column md={3} className={'label text-end fw-bold'}>
          <span className={"text-danger"}>* </span>{propTitle}
        </Form.Label>
        <Col md={9}>
          <Row>
            {Array.isArray(trgtAlarmList) ?
                (trgtAlarmList.map((elem, idx) => {
                  return (
                      <Col key={idx} className={'checkbox'}>
                        <input type={"checkbox"} name={elem.cd} id={elem.cd} className={""}
                               onChange={(e) => {
                                 propOnChange(e, idx)
                               }}
                               checked={(propDefaultValue === '') ? undefined : propDefaultValue[idx] === '1'}
                        />
                        <label htmlFor={elem.cd} className={'label text-end ps-1'} name={"mon"}>
                          {elem.nm}
                        </label>
                      </Col>
                  )
                })) : ''}
          </Row>
        </Col>
      </Form.Group>
  );
};

export default ComboSendTargetFault;